export default "__VITE_ASSET__Ci0v$7yU__"